import { useEffect, useState } from "react";
import axios from "axios";
import VideoEmbed from "@/components/VideoEmbed";
import KineticMarquee from "@/components/KineticMarquee";
import { FALLBACK_VIDEOS, SOCIAL_LINKS } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Videos() {
  const [videos, setVideos] = useState(FALLBACK_VIDEOS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/videos`)
      .then((r) => {
        if (mounted && r.data?.videos?.length) setVideos(r.data.videos);
      })
      .catch(() => {})
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div data-testid="videos-page" className="px-6 lg:px-12 py-16 lg:py-24 text-[var(--tsws-green)]">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-12">
        <div className="lg:col-span-8">
          <span className="font-label text-xs text-[var(--tsws-cigar)]">⏤ Watch Now</span>
          <h1 className="font-display text-7xl md:text-8xl lg:text-[12rem] mt-3 leading-[0.82]">
            every<br />
            episode<span className="text-[var(--tsws-cigar)]">.</span>
          </h1>
        </div>
        <div className="lg:col-span-4">
          <p className="font-tag text-xl">Raw. Uncut. Weekly.</p>
          <p className="mt-3 leading-relaxed opacity-85">
            The full archive — fights, rappers, mad lads, quiet legends. Newest at the top.
          </p>
          <a
            href={SOCIAL_LINKS.youtube}
            target="_blank"
            rel="noreferrer"
            data-testid="videos-youtube-link"
            className="inline-block mt-6 font-display text-base px-5 py-3 border-2 border-[var(--tsws-green)] hover:bg-[var(--tsws-green)] hover:text-[var(--tsws-orange)]"
          >
            subscribe on youtube →
          </a>
        </div>
      </div>

      <KineticMarquee phrases={["raw", "uncut", "weekly", "aussie", "pure banter"]} />

      {loading && (
        <div className="my-6 font-label text-sm opacity-60">Loading archive...</div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 mt-16">
        {videos.map((v, i) => (
          <article
            key={v.id}
            data-testid={`video-card-${v.id}`}
            className="group"
          >
            <div className="hover-brutal">
              <VideoEmbed id={v.id} title={v.title} testId={`video-embed-${v.id}`} />
            </div>
            <div className="mt-4 flex items-start justify-between gap-4">
              <div>
                <div className="font-label text-xs opacity-60">TSWS #{v.episode || i + 1}</div>
                <h3 className="font-display normal-case text-2xl mt-1 leading-tight group-hover:text-[var(--tsws-cigar)] transition-colors">
                  {v.title}
                </h3>
              </div>
              <span className="font-tag text-base whitespace-nowrap pt-1 opacity-80">
                {v.duration}
              </span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
